module.exports = __webpack_public_path__ + "static/img/huodongshangpin_xinqite_moren@2x.baf3d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huodongshangpin_xinqite_moren@2x.png
// module id = 462
// module chunks = 1